import { render, staticRenderFns } from "./TentShow.vue?vue&type=template&id=58ba5763&scoped=true"
import script from "./TentShow.vue?vue&type=script&lang=ts"
export * from "./TentShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ba5763",
  null
  
)

export default component.exports